import { createSlice } from "@reduxjs/toolkit";
import { getQuickTransfers, deleteQuickTransfer, getAllUsers, addQuickTransferDetails, updateQuickTransferDetails } from "./_quickTransferAction";

const initialState: any = {
  data: [],
  isLoading: true,
  isDeleting: false,
  isAdding: false,
  isUpdating: false,
  isSuccess: false,
  responseCode: null,
  responseMessage: '',
  totalRecord: 0,
  users: [],
  isUsersLoading: false,
  pageSize: 100,
};

export const quickTransferList = createSlice({
  name: "quickTransferList",
  initialState: initialState,
  reducers: {
    setQuickTransferPageSize: (state, { payload }) => {
      state.pageSize = Number(payload);
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getQuickTransfers.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getQuickTransfers.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload.data||[];
        state.responseMessage = payload.responseMessage
        state.responseCode = payload.responseCode
        state.totalRecord = payload.totalRecord || 0
      })
      .addCase(getQuickTransfers.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      })
      .addCase(addQuickTransferDetails.pending, (state) => {
        state.isAdding = true;
      })
      .addCase(addQuickTransferDetails.fulfilled, (state) => {
        state.isAdding = false;
      })
      .addCase(addQuickTransferDetails.rejected, (state) => {
        state.isAdding = false;
      })
      .addCase(updateQuickTransferDetails.pending, (state) => {
        state.isUpdating = true;
      })
      .addCase(updateQuickTransferDetails.fulfilled, (state) => {
        state.isUpdating = false;
      })
      .addCase(updateQuickTransferDetails.rejected, (state) => {
        state.isUpdating = false;
      })
      .addCase(deleteQuickTransfer.pending, (state) => {
        state.isDeleting = true;
      })
      .addCase(deleteQuickTransfer.fulfilled, (state) => {
        state.isDeleting = false;
      })
      .addCase(deleteQuickTransfer.rejected, (state) => {
        state.isDeleting = false;
      })
      .addCase(getAllUsers.pending, (state) => {
        state.isUsersLoading = true;
      })
      .addCase(getAllUsers.fulfilled, (state, { payload }) => {
        state.isUsersLoading = false;
        state.users = payload.data || [];
      })
      .addCase(getAllUsers.rejected, (state) => {
        state.isUsersLoading = false;
      })
  },
});

export const { setQuickTransferPageSize } = quickTransferList.actions;
